import script from "./menuSx.vue?vue&type=script&setup=true&lang=js"
export * from "./menuSx.vue?vue&type=script&setup=true&lang=js"

import "./menuSx.vue?vue&type=style&index=0&id=813ebcb4&lang=less&scoped=true"

import exportComponent from "D:\\project\\zillion\\developCompany\\pzh_develop_website发展集团官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-813ebcb4"]])

export default __exports__